export const actionTypes = {
  REQUEST_START: 'PROFILE.REMOVE_CERTIFICATE.REQUEST_START',
  REQUEST_SUCCESS: 'PROFILE.REMOVE_CERTIFICATE.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.REMOVE_CERTIFICATE.REQUEST_FAILURE',
  RESET: 'PROFILE.REMOVE_CERTIFICATE.RESET',
};

export function startRequest(data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
